import {Component} from "@angular/core";
import {DxBaseControlComponent} from "../dx-base-control.component";
import {DxTextareaControlOptions} from "../../../domain/ui-options/dx-textarea-control-options";


/** Копонент для ввода большого текста. */
@Component({
  selector: 'dx-textarea',
  templateUrl: './dx-textarea.component.html',
  styleUrls: ['./dx-textarea.component.css']
})
export class DxTextareaComponent extends DxBaseControlComponent {

  /** Опции контрола */
  public get controlOptions(): DxTextareaControlOptions {
    return <DxTextareaControlOptions>this.options;
  }

  protected _init(): void {
    super._init();
    if (!this.options) this.options = new DxTextareaControlOptions();
    if (!this.controlOptions.placeholder) this.controlOptions.placeholder = '';
  }

}
